import useAuthStore from '@store/AuthStore';
import useUserPreferencesStore from '@store/UserPreferencesStore';

export const useUserProfile = () => {
  const { userData, userCard, currentAccess } = useAuthStore((state) => state.authSession);
  const { userId } = useUserPreferencesStore((state) => state.userPreferences);

  const nameParts = (userCard?.fullName ?? userData?.fullName)?.split(' ') ?? [];
  const firstName = userCard?.firstName ?? nameParts[0];
  const lastName = userCard?.lastName ?? nameParts.slice(1).join(' ');

  let phone = '';
  let email = '';

  if (userData) {
    const { profile } = userData;

    phone = userCard?.phones?.[0]?.number ?? profile?.phones?.[0]?.number ?? '';
    email = userCard?.emails?.[0]?.address ?? profile?.emails?.[0]?.address ?? '';
  }

  return {
    userId,
    firstName,
    lastName,
    phone,
    email,
    displayName: userData?.displayName,
    organizationName: currentAccess?.tenantName,
    role: currentAccess?.role,
  };
};
